export default __webpack_public_path__ + "static/media/project6.5371f41a.png";